export default __webpack_public_path__ + "static/media/undraw_feeling_blue_-4-b7q.25a59af0.svg";